import { Card, Typography } from "antd";
import type { ReactNode } from "react";

type Props = {
  title: ReactNode;
  subtitle?: ReactNode;
  handleSelect: () => void;
};

const ItemCard = ({ title, subtitle, handleSelect }: Props) => (
  <Card className="startup-item-card" onClick={handleSelect}>
    <Typography.Text className="startup-item-card-title">{title}</Typography.Text>
    {subtitle && <Typography.Text className="startup-item-card-subtitle">{subtitle}</Typography.Text>}
  </Card>
);

export default ItemCard;
